import React from 'react';
import { AppState } from '../../store/state';
import { AppDispatch } from '../../store/store';
import { connect } from 'react-redux';
import { selectInfo, selectKeywordState, selectSubmissionState } from '../../store/selectors';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { TableFriendlyName } from '../../store/info/types';
import { Submission } from '../../store/submission/types';
import Loading from '../../components/Loading/Loading';
import { getSubmissionRow } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import useFetchTableData from '../../store/table/useFetchTableData';

interface Props {
  submissionsById: { [key: string]: Submission };
  loading: boolean;
  keywordById: { [key: number]: Keyword };
}

const AllSubmissionsPage: React.FC<Props> = ({ submissionsById, loading, keywordById }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'submissions';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  const inputData: unknown[] = Object.values(submissionsById).map((submission) =>
    getSubmissionRow(submission, true, keywordById, t),
  );

  return (
    <div className="flex flex-col h-full">
      <div className="h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
            getCustomColumnsData={fetchCustomColumnsData}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  submissionsById: selectSubmissionState(state).submissionsById,
  loading: selectInfo(state).loading || selectSubmissionState(state).loading,
  keywordById: selectKeywordState(state).keywordById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AllSubmissionsPage);
